import { SIDEBAR_ACTIONS } from 'config';

export function reflectSidebar(payload) {
  return {
    type: SIDEBAR_ACTIONS.CHANGE_SIDEBAR,
    payload
  };
}

export function setUserType(payload) {
  return {
    type: SIDEBAR_ACTIONS.SET_USER_TYPE,
    payload
  };
}
